{
  "next": "Successivo",
  "previous": "Precedente"
}
